<template>
  <button
    @click="toggleTheme"
    class="btn btn-ghost btn-sm btn-circle"
    :aria-label="theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
  >
    <Icon
      :icon="theme === 'dark' ? 'feather:sun' : 'feather:moon'"
      class="w-5 h-5"
    />
  </button>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import { Icon } from "@iconify/vue";

const theme = ref<"light" | "dark">("dark");

const toggleTheme = () => {
  theme.value = theme.value === "light" ? "dark" : "light";
};

// Apply + persist whenever the theme changes.
watch(theme, (newTheme) => {
  document.documentElement.setAttribute("data-theme", newTheme);
  localStorage.setItem("theme", newTheme);
});

// Initialize from the data-theme attribute set by the early init script in index.html.
onMounted(() => {
  const currentTheme = document.documentElement.getAttribute("data-theme");
  if (currentTheme === "dark" || currentTheme === "light") {
    theme.value = currentTheme;
  }
});
</script>
